import { create } from "zustand"
import { IPaginationMeta } from "../../types"
import { IUser } from "../../types/user.type"
import { devtools, persist } from "zustand/middleware"

interface IUserState {
  userData: IUser
  meta?: IPaginationMeta
  isLoading: boolean
  error: string | null
  setUserData: (userData: IUser) => void
  clearError: () => void
  reset: () => void
}

const initialState = {
  userData: {} as IUser,
  meta: undefined,
  isLoading: false,
  error: null,
}

export const useUserStore = create<IUserState>()(
  devtools(
    persist(
      (set) => ({
        ...initialState,

        setUserData: (userData: IUser) => {
          set({ userData, error: null })
          localStorage.setItem("session_farms", JSON.stringify(userData))
        },

        clearError: () => set({ error: null }),
        
        reset: () => {
          set({ ...initialState })
          localStorage.removeItem("session_farms")
        },
      }),
      {
        name: "session_farms",
        partialize: (state) => ({ userData: state.userData }), 
        onRehydrateStorage: () => (state) => {
          if (state) {
            console.log("✅ User data rehydrated from session_farms")
            if (state.userData && Object.keys(state.userData).length > 0) {
              localStorage.setItem("session_farms", JSON.stringify(state.userData))
            }
          }
        },
      }
    )
  )
)
